import snapshot from './pdfOptionsCatalog.json';

export const pdfOptionDefinitions = catalog =>
  (catalog?.groups || []).flatMap(group => group.options);

export const validatePDFCatalog = catalog => {
  if (
    catalog?.schema_version !== 1 ||
    !catalog.groups?.length ||
    pdfOptionDefinitions(catalog).some(
      option =>
        !['boolean', 'choice', 'multi_choice'].includes(option.type) ||
        !option.key ||
        (option.type !== 'boolean' && !option.choices?.length)
    )
  ) {
    throw new Error('These PDF options require an updated app. Please reload.');
  }
  return catalog;
};

export const fallbackPDFCatalog = templateName => ({
  ...snapshot,
  groups: snapshot.groups.map(group => ({
    ...group,
    options: group.options.map(option => ({
      ...option,
      default:
        option.template_defaults?.[templateName?.trim().toLowerCase()] ??
        option.default,
    })),
  })),
});

export const pdfOptionDefaults = catalog =>
  Object.fromEntries(
    pdfOptionDefinitions(catalog).map(option => [option.key, option.default])
  );

export const pdfOptionsPayload = (catalog, values, live = true) => ({
  ...(live ? { options_schema_version: catalog.schema_version } : {}),
  ...Object.fromEntries(
    pdfOptionDefinitions(catalog).map(option => [
      option.key,
      values[option.key] ?? option.default,
    ])
  ),
});
